/**
 * Valid DTMF digit type
 */
export type DTMFDigit = '0' | '1' | '2' | '3' | '4' | '5' | '6' | '7' | '8' | '9' | '*' | '#';

/**
 * Digit labels (sub-text for traditional phone layout)
 */
export const DIGIT_LABELS: Record<DTMFDigit, string> = {
  '1': '',
  '2': 'ABC',
  '3': 'DEF',
  '4': 'GHI',
  '5': 'JKL',
  '6': 'MNO',
  '7': 'PQRS',
  '8': 'TUV',
  '9': 'WXYZ',
  '*': '',
  '0': '+',
  '#': '',
};

/**
 * Digit grid layout (3x4 grid)
 * Used by both keypad and dialpad components
 */
export const DIGIT_GRID: readonly (readonly DTMFDigit[])[] = [
  ['1', '2', '3'],
  ['4', '5', '6'],
  ['7', '8', '9'],
  ['*', '0', '#'],
] as const;
